import { TRANSFORMERS } from '@lexical/markdown'
import {
    $createHorizontalRuleNode,
    $isHorizontalRuleNode,
    HorizontalRuleNode
} from "@lexical/react/LexicalHorizontalRuleNode"

const debug = false
// const debug = "lexicalGetTransformers"

export function lexicalGetTransformers(): any {

    const HORIZONTAL_RULE = {
        dependencies: [HorizontalRuleNode],
        export: (node:any) => {
            if (!$isHorizontalRuleNode(node)) {
                return null;
            }
            return '---'
        },
        regExp: /^---\s/,
        replace: (parentNode: any, children: any, _match: any, isImport: any) => {
            if (isImport) {
                const previousNode = parentNode.getPreviousSibling()
                if ($isHorizontalRuleNode(previousNode)) {
                    parentNode.remove()
                    return
                }
            }
            const node = $createHorizontalRuleNode()
            parentNode.replace(node)
        },
        type: 'element'
    };

    const STRIKETHROUGH = {
        format  : ['strikethrough'],
        tag     : '~',
        type    : 'text-format'
    }

    return [...TRANSFORMERS, STRIKETHROUGH, HORIZONTAL_RULE]
}